<template>
  <div class="content">
    <div class="content-select">
      <el-row :gutter="20">
        <el-col :span="4">
          <div class="select-title">
            <div class="title-img">
              <img src="@/assets/appraisal/select-icon.png" alt="" />
            </div>
            <div class="title-info">
              <span>培训项目管理</span>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="content-header">
      <myTableSearch
        :isOperate="true"
        :operateWidth="230"
        :formData="formData"
        :tableLabel="tableLabel"
        :queryFn="queryFn"
        :queryParams="queryParams"
        @successQuery="successQuery"
        :searchColLg="6"
        ref="tableRef"
        dataRow="rows"
      >
        <template slot="cultivateInstitutionTrainingItemList" slot-scope="scope">
          <span
            v-if="
              scope.row.cultivateInstitutionTrainingItemList &&
              scope.row.cultivateInstitutionTrainingItemList.length > 0
            "
            style="white-space: nowrap"
          >
            <span v-for="(item, index) in scope.row.cultivateInstitutionTrainingItemList" :key="index">
              {{ item.name || "" }}{{ item.level ? "（" + item.level + "）" : "" }}
              <span v-if="index < scope.row.cultivateInstitutionTrainingItemList.length - 1">、</span>
            </span>
          </span>
          <span v-else>-</span>
        </template>
        <template slot="ifSupervisorExamine" slot-scope="scope">
          <span>{{ scope.row.ifSupervisorExamine == 1 ? "是" : "否" }}</span>
        </template>
        <template slot="ifSafetyExamine" slot-scope="scope">
          <span>{{ scope.row.ifSafetyExamine == 1 ? "是" : "否" }}</span>
        </template>
        <template slot="licenseValidDate" slot-scope="scope">
          <span v-if="scope.row.licenseValidStart && scope.row.licenseValidEnd" style="white-space: nowrap">
            {{ scope.row.licenseValidStart }} 至 {{ scope.row.licenseValidEnd }}
          </span>
          <span v-else-if="scope.row.licenseValidStart" style="white-space: nowrap">{{
            scope.row.licenseValidStart
          }}</span>
          <span v-else>-</span>
        </template>
        <template slot="tool">
          <div class="toolbar-container">
            <div class="toolbar-left">
              <div class="tool-btn" @click="handleRefresh" title="刷新">
                <!-- <img :src="refreshIcon" alt="刷新" class="toolbar-icon"> -->
                <el-button
                  type="primary"
                  icon="el-icon-circle-plus-outline"
                  style="margin-left: 60px"
                  @click="handleAddAppointment"
                  >添加培训项目</el-button
                >
              </div>
            </div>
            <!-- <div class="toolbar-right">
              <el-button
                plain
                type="info"
                icon="el-icon-fake custom-icon icon-policy-download"
                :loading="downloadTemplateLoading"
                @click="handleDownloadTemplate"
                >模板下载</el-button
              >
              <el-upload
                ref="uploadRef"
                action="#"
                :auto-upload="false"
                :show-file-list="false"
                :on-change="handleImportFile"
                accept=".xls,.xlsx"
                class="import-upload"
              >
                <el-button plain type="info" icon="el-icon-fake custom-icon icon-policy-insert" :loading="importLoading"
                  >批量导入</el-button
                >
              </el-upload> 
            </div>-->
          </div>
        </template>
        <template slot="operate" slot-scope="scope">
          <el-button @click="handleView(scope.row)" size="small" type="text">查看</el-button>
          <el-button @click="handleEdit(scope.row)" size="small" type="text">编辑</el-button>
          <el-button type="text" style="color: rgb(241, 74, 63)" size="small" @click="handleDel(scope.row)"
            >删除</el-button
          >
        </template>
      </myTableSearch>
      <!-- 新增 / 编辑 / 查看 -->
      <policyDialog
        v-if="isSubscribeDialog"
        :isDialog="isSubscribeDialog"
        :isEdit="isEdit"
        :isView="isView"
        :editData="editData"
        @handleClose="onPolicyDialogClose"
        @success="handleRefresh"
      >
      </policyDialog>
      <!-- 导入结果 -->
      <importResultDialog
        v-if="isImportResultDialog"
        :isDialog="isImportResultDialog"
        :resultData="importResultData"
        @handleClose="isImportResultDialog = false"
      >
      </importResultDialog>
    </div>
  </div>
</template>

<script>
import "@/assets/css/base.css";
import { getOrganizationLists, downloadTemplate, importOrganization, deleteOrganizations } from "@/api/training";
import { getListByDictType } from "@/api/sys/dictData";
import policyDialog from "./components/policyDialog.vue";
import importResultDialog from "./components/importResultDialog.vue";
import refreshIcon from "@/assets/pages/appointment/refresh.png";

export default {
  name: "PolicyList",
  components: {
    policyDialog,
    importResultDialog,
  },
  data() {
    return {
      refreshIcon,
      currentPage: 1,
      downloadTemplateLoading: false,
      importLoading: false,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        pageSizes: [10, 20, 50],
      },
      isSubscribeDialog: false, // 新增/编辑/查看弹窗
      isEdit: false,
      isView: false,
      editData: {}, //编辑/查看时的数据
      isImportResultDialog: false, //导入结果弹窗
      importResultData: "", //导入结果
      formData: [
        {
          label: "培训项目名称",
          type: "input",
          key: "name",
          colLg: 6,
          placeholder: "培训项目名称",
        },
        {
          label: "培训项目等级",
          type: "select",
          key: "levelCode",
          data: [],
          colLg: 6,
          placeholder: "培训项目等级",
        },
      ],
      tableLabel: [
        {
          prop: "name",
          label: "培训项目名称",
        },
        {
          prop: "levelName",
          label: "培训项目等级",
        },
      ],
    };
  },
  mounted() {
    this.loadProjectLevelDict();
  },
  methods: {
    // 获取列表数据
    queryFn(queryParams) {
      return getOrganizationLists(queryParams);
    },
    /** 与 policyDialog 一致：培训项目等级字典 cultivate_project_level */
    async loadProjectLevelDict() {
      try {
        const res = await getListByDictType("cultivate_project_level");
        if (res && res.code === 200 && res.data) {
          this.applyLevelSelectOptions(res.data);
        }
      } catch (e) {
        console.error("加载培训项目等级字典失败", e);
      }
    },
    applyLevelSelectOptions(gradeData) {
      if (!gradeData) return;
      const idx = this.formData.findIndex((item) => item.key === "levelCode");
      if (idx === -1) return;
      const dataWithAll = [{ dictLabel: "全部", dictValue: "" }, ...gradeData];
      this.$set(this.formData[idx], "data", dataWithAll);
    },
    onPolicyDialogClose() {
      this.isSubscribeDialog = false;
      this.isView = false;
      this.isEdit = false;
    },
    // 上一页
    handlePrevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.queryParams.pageNum = this.currentPage;
        this.$refs.tableRef && this.$refs.tableRef.handleSearch();
      }
    },
    // 下一页
    handleNextPage() {
      this.currentPage++;
      this.queryParams.pageNum = this.currentPage;
      this.$refs.tableRef && this.$refs.tableRef.handleSearch();
    },
    // 刷新列表
    handleRefresh() {
      this.queryParams.pageNum = 1;
      this.currentPage = 1;
      this.$refs.tableRef && this.$refs.tableRef.handleSearch();
    },
    // 删除
    handleBatchDelete() {
      this.$refs.tableRef && this.$refs.tableRef.deleteAll();
    },
    // 下载导入模板
    handleDownloadTemplate() {
      this.downloadTemplateLoading = true;
      downloadTemplate({})
        .then((res) => {
          if (res) {
            this.downloadBlobFile(res, "机构导入模板.xls");
          }
        })
        .catch((err) => {
          console.error("下载失败", err);
          this.$message.error("下载失败");
        })
        .finally(() => {
          this.downloadTemplateLoading = false;
        });
    },
    // 导入文件
    handleImportFile(file) {
      const isExcel =
        file.raw.type === "application/vnd.ms-excel" ||
        file.raw.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      const isLt10M = file.raw.size / 1024 / 1024 < 10;

      if (!isExcel) {
        this.$message.error("只能上传 .xls 或 .xlsx 格式的文件！");
        return;
      }
      if (!isLt10M) {
        this.$message.error("文件大小不能超过 10MB！");
        return;
      }

      this.importLoading = true;
      const formData = new FormData();
      formData.append("file", file.raw);

      importOrganization(formData)
        .then((res) => {
          if (res && res.code === 200) {
            this.importResultData = res.data;
            this.isImportResultDialog = true;
            this.handleRefresh();
          } else {
            this.$message.error(res.msg || "导入失败");
          }
        })
        .catch((err) => {
          console.error("导入出错", err);
          this.$message.error("导入失败");
        })
        .finally(() => {
          this.importLoading = false;
          this.$refs.uploadRef && this.$refs.uploadRef.clearFiles();
        });
    },
    handleAddAppointment() {
      this.isEdit = false;
      this.isView = false;
      this.editData = {};
      this.isSubscribeDialog = true;
    },
    handleView(row) {
      this.isEdit = false;
      this.isView = true;
      this.editData = { ...row };
      this.isSubscribeDialog = true;
    },
    handleEdit(row) {
      this.isView = false;
      this.isEdit = true;
      this.editData = { ...row };
      this.isSubscribeDialog = true;
    },
    // 删除机构
    handleDel(row) {
      this.$confirm("确定要删除该培训项目吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteOrganizations({ id: row.id })
            .then((res) => {
              if (res && res.code === 200) {
                this.$message.success("删除成功");
                this.handleRefresh();
              } else {
                this.$message.error(res.msg || "删除失败");
              }
            })
            .catch((err) => {
              console.error("删除失败", err);
              this.$message.error("删除失败");
            });
        })
        .catch(() => {});
    },
    // 更新总数
    successQuery(e) {
      this.syrkNum = e.total;
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  width: 100%;
  height: 100%;
  background: #fff;
  display: flex;
  flex-direction: column;

  &-select {
    height: 50px;
    .select-title {
      height: 46px;
      background: url("~@/assets/appraisal/selectBg.png") no-repeat;
      background-size: 100% 100%;
      display: flex;
      align-items: center;
      gap: 12px;
      padding-left: 16px;
      .title-img {
        width: 18px;
        height: 18px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .title-info {
        color: var(--vt-c-black-mute-soft);
        font-size: 16px;
        font-weight: 700;
      }
    }
    .select-serch {
      margin-top: 12px;
      display: flex;
      align-items: center;
      gap: 8px;
      .serch-hint {
        color: var(--vt-c-black-mute-soft);
        font-size: 14px;
        font-weight: 400;
      }
      .serch-info {
        height: 28px;
        display: flex;
        align-items: center;
        gap: 12px;
        .info-item {
          width: 120px;
          height: 28px;
          text-align: center;
          line-height: 28px;
          background: var(--vt-c-blue-mute);
          color: var(--vt-c-blue);
          border-radius: 2px;
          cursor: pointer;
          transition: all 0.3s ease;

          &:hover {
            opacity: 0.8;
          }

          &.active {
            background: var(--vt-c-blue);
            color: var(--vt-c-white);
          }

          &:active:not(.active) {
            transform: scale(0.98);
          }
        }
      }
    }
  }
  &-header {
    padding: 0 24px;
    overflow: hidden;
    display: flex;
    flex-direction: column;

    /deep/.myTableSearch {
      padding: 0;
      height: 740px;
      display: flex;
      flex-direction: column;

      /deep/.el-table {
        flex: 1;
        overflow: auto;
      }
    }
  }
}

.link-text {
  color: #409eff;
  text-decoration: none;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
}

.toolbar-container {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;

  .toolbar-icon {
    width: 24px;
    height: 24px;
  }

  .add-icon {
    width: 20px;
    height: 20px;
    margin-right: 6px;
  }

  .toolbar-left {
    display: flex;
    align-items: center;
    gap: 12px;
    .tool-btn {
      width: 36px;
      height: 36px;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid #dcdfe6;
      cursor: pointer;
      transition: all 0.2s;
      background-color: #fcfcfcff;
    }
    .list-title {
      font-size: 14px;
      font-weight: 400;
      color: var(--vt-c-blue-soft);
    }
  }

  .toolbar-right {
    display: flex;
    align-items: center;
    gap: 12px;

    .import-upload {
      display: inline-block;

      /deep/.el-upload {
        display: inline-block;
      }
    }

    .el-button {
      height: 36px;
      padding: 0 16px;
    }
  }
}
</style>
